import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import Helmet from 'react-helmet';
import { NavItem, Button } from 'react-bootstrap';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import BenchmarkIndex from './BenchmarkIndexPage';
import { requestSyncResource } from '../../SetupActions';
import requiredSetupMappings from '../../../../components/required-setup-mappings';

class BenchmarkPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      syncing: false,
    };
    this.requestSync = this.requestSync.bind(this);
  }

  requestSync() {
    if (!this.state.syncing) {
      this.setState({ syncing: true }, () => {
        this.props.dispatch(requestSyncResource('benchmarks'));
      });
    }
  }

  render() {
    const { location: { pathname } } = this.props;

    const comps = [
      {
        uri: 'outcomes',
        label: 'Outcome Rates',
        title: 'Outcome Rate Benchmark Settings',
        description: 'Adjust the settings for each outcome rate metric to match your organization\'s opportunity types.',
      },
      {
        uri: 'pipelines',
        label: 'Pipeline Benchmarks',
        title: 'Pipeline Benchmark Settings',
        description: 'Adjust the settings for each pipeline metric to match your organization\'s needs.',
      },
      {
        uri: 'forecasts',
        label: 'Forecast Benchmarks',
        title: 'Forecast Benchmark Settings',
        description: 'Adjust the settings for each forecast metric to match your organization\'s needs.',
      },
    ];

    return (
      <div className="container">
        <Helmet title="Benchmark Settings | Organization Setup" />
        <div className="clearfix">
          <div className="pull-left">
            <ul className="nav nav-tabs">
              {comps.map(comp => (
                <LinkContainer key={comp.uri} to={`/setup/benchmarks/${comp.uri}`}>
                  <NavItem>{comp.label}</NavItem>
                </LinkContainer>
              ))}
            </ul>
            <p />
          </div>
          <div className="pull-right">
            <Button disabled={this.state.syncing} onClick={this.requestSync} bsStyle="default"><Fa spin={this.state.syncing} name="refresh" /> Sync Benchmark Now</Button>
          </div>
        </div>
        {(pathname === '/setup/benchmarks' && <Redirect to="/setup/benchmarks/outcomes" />)}
        <Switch>
          {comps.map((comp) => {
            return (
              <Route
                key={comp.uri}
                path={`/setup/benchmarks/${comp.uri}`}
                render={(props) => {
                  return (
                    <div>
                      <Helmet title={`${comp.title} | Organization Setup`} />
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          <div className="panel-title">
                            {comp.title}
                          </div>
                        </div>
                        <div className="panel-body">
                          <p>
                            {comp.description}
                          </p>
                          <BenchmarkIndex type={comp.uri} {...props} />
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
            );
          })}
        </Switch>
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

BenchmarkPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};
BenchmarkPage.defaultProps = {
};

export default connect(mapStateToProps)(requiredSetupMappings(withRouter(BenchmarkPage), ['stage', 'dealType'], true));
